// ProjectSlice.js
import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
    name: 'project',
    initialState: {
        list: [],
        selectedProject: null,
        isModalVisible: false,
    },
    reducers: {
        setProjectList(state, action) {
            state.list = action.payload;
        },
        setSelectedProject(state, action) {
            if(!action.payload.serviceId)
            {
                state.selectedProject={serviceId:'',price:'',serviceName:'',description: ''}
            }
            else{
                state.selectedProject = action.payload;
            }
        },
        setModalVisibility(state, action) {
            state.isModalVisible = action.payload;
        },
        clearSelectedProject(state) {
            state.selectedProject = null;
            console.log(state.selectedProject);
        },
    },
});

export const { setProjectList, setSelectedProject, setModalVisibility, clearSelectedProject } = projectSlice.actions;
export default projectSlice.reducer;
